import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [
  'snow_flakes',
  'any_solvent',
  'no_bleach',
  'no_dry_clean',
  'no_tumble_dry',
  'no_wash',
  'hand_wash',
  'iron_low',
  'account',
  'account-logged-in',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'assistance',
  'calendar',
  'cart',
  'close',
  'contact-us',
  'coupon',
  'facebook',
  'fast-delivery',
  'hidden',
  'info',
  'instagram',
  'linkedin',
  'logout',
  'privacy',
  'settings',
  'visible',
  'youtube',
] as const;
export type IconName = (typeof iconsNames)[number];

export type IconSize = 10 | 12 | 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 34 | 36 | 40 | 44 | 48 | 50 | 72;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
